import { Fragment } from 'react';

interface QuickCategoryLinksProps {
  categories: readonly string[];
  onJump: (category: string) => void;
  /** Se ocultan mientras hay una búsqueda activa (la lista ya no está agrupada). */
  visible: boolean;
}

export function QuickCategoryLinks({ categories, onJump, visible }: QuickCategoryLinksProps) {
  return (
    <div
      className={
        'flex flex-wrap transition-[max-height,opacity] duration-150 ' +
        (visible ? 'mb-4 max-h-16 opacity-100' : 'mb-0 max-h-0 overflow-hidden opacity-0')
      }
    >
      {categories.map((category, i) => (
        <Fragment key={category}>
          {i > 0 && <span className="mx-1.5 text-label text-subtle">·</span>}
          <button
            type="button"
            onClick={() => onJump(category)}
            className="text-label font-medium text-muted hover:text-brand hover:underline"
          >
            {category}
          </button>
        </Fragment>
      ))}
    </div>
  );
}
